import { render } from "./imgAndContent.vue?vue&type=template&id=08e167bb&scoped=true"
import script from "./imgAndContent.vue?vue&type=script&lang=js"
export * from "./imgAndContent.vue?vue&type=script&lang=js"

import "./imgAndContent.vue?vue&type=style&index=0&id=08e167bb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e167bb"]])

export default __exports__